<template>
	<a class="atom-skip-to-content-button" :href="href" @click="handle_click">
		<slot>Skip to main content</slot>
	</a>
</template>

<script>
export default {
	name: 'AtomSkipToContentButton',
	props: {
		href: {
			type: String,
			default: '#main-content'
		}
	},
	mounted() {
		this.validate_skip_target()
	},
	methods: {
		// We validate both on mount and on click so broken skip-link wiring is visible during development
		// even if nobody tests the control, while still guarding against targets that disappear later.
		validate_skip_target() {
			if (!this.href || !this.href.startsWith('#')) return true
			const target = document.querySelector(this.href)
			if (target) return true
			console.warn(`[AtomSkipToContentButton] Could not find skip target for href "${this.href}".`)
			return false
		},
		find_focus_target(target) {
			const preferred_target = target.querySelector('[data-main-focus-start="true"]')
			if (preferred_target && this.is_visible(preferred_target)) return preferred_target
			return target
		},
		is_visible(element) {
			if (!element) return false
			const style = window.getComputedStyle(element)
			return style.display !== 'none' && style.visibility !== 'hidden'
		},
		handle_click(event) {
			if (!this.validate_skip_target()) return
			if (!this.href || !this.href.startsWith('#')) return

			const target = document.querySelector(this.href)
			if (!target) return

			event.preventDefault()
			const focus_target = this.find_focus_target(target)
			const previous_tabindex = focus_target.getAttribute('tabindex')
			if (!focus_target.hasAttribute('tabindex')) focus_target.setAttribute('tabindex', '-1')
			focus_target.focus()
			if (previous_tabindex === null) {
				focus_target.addEventListener('blur', () => focus_target.removeAttribute('tabindex'), { once: true })
			}
			if (typeof target.scrollIntoView === 'function') {
				target.scrollIntoView({ block: 'start' })
			}
		}
	}
}
</script>

<style scoped>
.atom-skip-to-content-button {
	align-items: center;
	background: #0d47a1;
	border: 0;
	border-radius: 999px;
	clip: rect(0 0 0 0);
	clip-path: inset(50%);
	color: #fff;
	display: inline-flex;
	font-weight: 600;
	height: 1px;
	justify-content: center;
	left: 1rem;
	margin: -1px;
	max-width: max-content;
	min-width: 0;
	overflow: hidden;
	padding: 0.75rem 1rem;
	position: fixed;
	text-decoration: none;
	top: 1rem;
	transform: translateY(-1rem);
	transition: transform 0.2s ease;
	white-space: nowrap;
	width: 1px;
	z-index: 2000;
}

.atom-skip-to-content-button:focus {
	background: #0d47a1 !important;
	clip: auto;
	clip-path: none;
	color: #ffffff !important;
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
	height: auto;
	margin: 0;
	overflow: visible;
	transform: translateY(0);
	width: auto;
}

.atom-skip-to-content-button:hover {
	color: #fff;
}
</style>
